import React from "react";

import { FunctionField } from "react-admin";

const VisitNumberRepairReportField = ({ record, visits }) => {
  const visit = (visits && visits.find((visit) => record.visit === visit.id)) || {};
  return <FunctionField render={(record) => `${visit.visit_number}` || record.visit} />;
};
export default VisitNumberRepairReportField;
